import React, { useState, useEffect } from 'react';
import './CountryClocks.css';

// Flag images - you'll need to add these to your public folder
const countryData = [
  { id: 1, name: 'USA', timezone: 'America/New_York', flag: '/Logo/usa.jpg' },
  { id: 2, name: 'UK', timezone: 'Europe/London', flag: '/Logo/uk.jpg' },
  { id: 3, name: 'BRAZIL', timezone: 'America/Sao_Paulo', flag: '/Logo/brazil.jpg' },
  { id: 4, name: 'CHINA', timezone: 'Asia/Shanghai', flag: '/Logo/china.jpg' },
  { id: 5, name: 'PAKISTAN', timezone: 'Asia/Karachi', flag: '/Logo/pakistan.jpg' }
];

function CountryClocks() {
  const [times, setTimes] = useState({});
  const [clockHands, setClockHands] = useState({});

  useEffect(() => {
    // Function to update all clocks
    const updateClocks = () => {
      const newTimes = {};
      const newClockHands = {};
      
      countryData.forEach(country => {
        try {
          // Get the current time in the country's timezone
          const now = new Date();
          const options = {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true,
            timeZone: country.timezone
          };
          
          // Digital time
          const timeString = now.toLocaleTimeString('en-US', options);
          newTimes[country.id] = timeString;
          
          // Get hours, minutes, seconds for the analog clock
          const timeParts = new Intl.DateTimeFormat('en-US', {
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false,
            timeZone: country.timezone
          }).formatToParts(now);
          
          // Extract hours, minutes, seconds from the formatted parts
          const hours = parseInt(timeParts.find(part => part.type === 'hour').value);
          const minutes = parseInt(timeParts.find(part => part.type === 'minute').value);
          const seconds = parseInt(timeParts.find(part => part.type === 'second').value);
          
          // Calculate the rotation angles for clock hands
          const secondsDegrees = (seconds / 60) * 360;
          const minutesDegrees = ((minutes + seconds / 60) / 60) * 360;
          const hoursDegrees = ((hours % 12 + minutes / 60) / 12) * 360;
          
          newClockHands[country.id] = {
            hours: hoursDegrees,
            minutes: minutesDegrees,
            seconds: secondsDegrees
          };
        } catch (error) {
          console.error(`Error getting time for ${country.name}:`, error);
          newTimes[country.id] = 'Time unavailable';
          newClockHands[country.id] = { hours: 0, minutes: 0, seconds: 0 };
        }
      });
      
      setTimes(newTimes);
      setClockHands(newClockHands);
    };

    // Update immediately and then every second
    updateClocks();
    const intervalId = setInterval(updateClocks, 1000);
    
    // Clean up interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="country-clocks-container">
      <div className="country-clocks">
        {countryData.map((country) => (
          <div key={country.id} className="country-clock">
            {/* Flag at the top */}
            <div className="flag-container">
              <img src={country.flag} alt={`${country.name} flag`} className="country-flag" />
              <div className="country-name">{country.name}</div>
            </div>
            
            {/* Analog Clock in the middle */}
            <div className="analog-clock">
              <div className="clock-face">
                {/* Clock numbers */}
                {[...Array(12)].map((_, i) => (
                  <div
                    key={i}
                    className="clock-number"
                    style={{
                      transform: `rotate(${i * 30}deg) translateY(-28px)`
                    }}
                  >
                    <span style={{ transform: `rotate(${-i * 30}deg)` }}>
                      {i === 0 ? '12' : i}
                    </span>
                  </div>
                ))}
                {/* Clock hands */}
                {clockHands[country.id] && (
                  <>
                    <div
                      className="hour-hand"
                      style={{ transform: `rotate(${clockHands[country.id].hours}deg)` }}
                    ></div>
                    <div
                      className="minute-hand"
                      style={{ transform: `rotate(${clockHands[country.id].minutes}deg)` }}
                    ></div>
                    <div
                      className="second-hand"
                      style={{ transform: `rotate(${clockHands[country.id].seconds}deg)` }}
                    ></div>
                    <div className="clock-center"></div>
                  </>
                )}
              </div>
            </div>
            
            {/* Digital time at the bottom */}
            <div className="country-time">{times[country.id] || '--:--:--'}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CountryClocks;
